// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"5aa43bba","489":"bb5e6867"}[chunkId] + ".chunk.js";
};